import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData 
    defaultData,
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) => {


    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const cerrarModal = () => {
        toggle()
    }

    const handleClickShowForm = () => {
        const { setShowForm } = globalStates
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const { setShowForm } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen
        const { fetchAllCashRegisters } = FetchData

        onResetForm()
        fetchAllCashRegisters.resetFetch()
        setShowForm(false)


    }

    const handleClickDeleteAssignment = async (idasignacion) => {

        const { fetchAssignments } = FetchData

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/caja/delete-assignment/${idasignacion}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    fetchAssignments.executeFetch()
                    cerrarModal()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchAssignments } = FetchData
        const { setLoadingSubmitForm } = globalStates
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        if (
            formState.idcaja === ''
            || formState.idusuario === ''
        ){
            alertMessage({
                flag: false,
                message: 'Para registrar la transacción debe completar todos los campos del formulario'
            })
            return
        }

        const _dataBody = {
            idasignacion: formState.idasignacion,
            idcaja: formState.idcaja,
            idusuario: formState.idusuario,
            user: user.username
        }


        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        setLoadingSubmitForm(true)
        await marvarApi.post(`/caja/save-assignment`, _dataBody)
            .then(({ data }) => {

                console.log('data ::: ', data)

                alertMessage(data)

                if (data.flag === 'FAIL'){
                    setLoadingSubmitForm(false)
                    return
                }
                
                onResetForm()
                handleClickHideForm()
                setLoadingSubmitForm(false)

                fetchAssignments.executeFetch()

            })
            .catch(error => {
                setLoadingSubmitForm(false)
                console.log('API ERROR: ', error)
            })
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickDeleteAssignment,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}